import React from 'react'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import FormNewsletterElementText from '../../forms/FormNewsletterElementText'
import FormNewsletterElementImage from '../../forms/FormNewsletterElementImage'
import Translation from '../../Translation/cont/Translation'

const EditNewsletterElement = ({
    itemData,
    itemType,
    closePagePath,
    onUpdateItem
}) => {
    const isText = 'text' === itemType
    const typeTransId  = isText ? 'print_flyer_text_element' : 'print_flyer_image_element'

    const pageName = typeTransId ? itemData && itemData.id
    ? [<Translation key="type" id={typeTransId}/>, <Translation key="edit" id="print_flyer_edit" before=" "/>] 
    : [<Translation key="new" id="print_flyer_new" after=" "/>, <Translation key="type" id={typeTransId}/>] 
    : ''

    return (
        <WrapperPageSimple pageTitle={pageName} closePagePath={closePagePath}>
            <div className="newsletter-page-campaign program-page site-content">
                {isText ? (
                    <FormNewsletterElementText
                        itemData={itemData}
                        closePagePath={closePagePath}
                        onUpdateItem={onUpdateItem}
                    />
                ):(
                    <FormNewsletterElementImage
                        itemData={itemData}
                        closePagePath={closePagePath}
                        onUpdateItem={onUpdateItem}
                    />
                )}

            </div>
        </WrapperPageSimple>
    )
}

export default EditNewsletterElement